import React, { Component } from 'react'
import { Col, Modal, Row, Tabs } from 'antd'
import SubsidiaryDetailsForm from './SubsidiaryDetailsForm'
import Avatar from '../../People/Member/Avatar'
import { strVal } from '../../../modules/Utils'

const TabPane = Tabs.TabPane

class SubsidiaryModal extends Component {
  render() {
    const { visible, onCancel, confirmLoading, member, formRef } = this.props
    return (
      <Modal
        title="Tenant Update"
        visible={visible}
        onCancel={onCancel}
        destroyOnClose={true}
        confirmLoading={confirmLoading}
        width={'65%'}
        footer={null}>
        <div>
          <Row>
            <Col xs={12} sm={6} md={6} style={{ textAlign: 'center  ' }}>
              <Avatar id={member._key} style={{ maxHeight: '150px', maxWidth: '140px' }} />
            </Col>
            <Col xs={12} sm={6} md={6} style={{ paddingTop: '20px' }}>
              <p style={{ fontWeight: 'bold' }}>{member.fn}</p>
              <p style={{ fontStyle: 'italic' }}>{member.position}</p>
              <p>{strVal(member, 'email.label')}</p>
            </Col>
          </Row>
          <Row>
            <Tabs defaultActiveKey="1" size="small">
              <TabPane tab="Corporate Details" key="1">
                <SubsidiaryDetailsForm ref={formRef} {...this.props} />
              </TabPane>
            </Tabs>
          </Row>
        </div>
      </Modal>
    )
  }
}

export default SubsidiaryModal
